export const UPDATE_DASHBOARD_STATE = 'UPDATE_DASHBOARD_STATE';
export const DASHBOARD_SOCKET_CONNECTED = 'DASHBOARD_SOCKET_CONNECTED';
export const DASHBOARD_SOCKET_CONNECT_ERROR = 'DASHBOARD_SOCKET_CONNECT_ERROR';
export const DASHBOARD_SOCKET_ERROR = 'DASHBOARD_SOCKET_ERROR';
export const LIVE_COUNT_PER_SEC = 'LIVE_COUNT_PER_SEC';
export const LIVE_COUNT_PER_MIN = 'LIVE_COUNT_PER_MIN';
export const LAST_N_HOURS_TIME_SERIES = 'LAST_N_HOURS_TIME_SERIES';
export const UPDATE_SCALE_PER_MIN = 'UPDATE_SCALE_PER_MIN';



// WEBPACK FOOTER //
// ./src/data/redux/dashboard_details/actiontypes.js